/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ProssimaAttivitaPerClienteDtoUltimaAttivitaModalitaEnum = {
    Mail: 'MAIL',
    Telefono: 'TELEFONO',
    Incontro: 'INCONTRO'
};
/**
 * @export
 */
export const ProssimaAttivitaPerClienteDtoUltimaAttivitaEsitoEnum = {
    Annullata: 'ANNULLATA',
    Positivo: 'POSITIVO',
    Negativo: 'NEGATIVO',
    Neutro: 'NEUTRO',
    DaEseguire: 'DA_ESEGUIRE'
};
/**
 * @export
 */
export const ProssimaAttivitaPerClienteDtoProssimaAttivitaModalitaEnum = {
    Mail: 'MAIL',
    Telefono: 'TELEFONO',
    Incontro: 'INCONTRO'
};
/**
 * Check if a given object implements the ProssimaAttivitaPerClienteDto interface.
 */
export function instanceOfProssimaAttivitaPerClienteDto(value) {
    return true;
}
export function ProssimaAttivitaPerClienteDtoFromJSON(json) {
    return ProssimaAttivitaPerClienteDtoFromJSONTyped(json, false);
}
export function ProssimaAttivitaPerClienteDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'idCliente': json['idCliente'] == null ? undefined : json['idCliente'],
        'nomeCliente': json['nomeCliente'] == null ? undefined : json['nomeCliente'],
        'ultimaAttivitaDate': json['ultimaAttivitaDate'] == null ? undefined : (new Date(json['ultimaAttivitaDate'])),
        'ultimaAttivitaModalita': json['ultimaAttivitaModalita'] == null ? undefined : json['ultimaAttivitaModalita'],
        'ultimaAttivitaEsito': json['ultimaAttivitaEsito'] == null ? undefined : json['ultimaAttivitaEsito'],
        'prossimaAttivitaDate': json['prossimaAttivitaDate'] == null ? undefined : (new Date(json['prossimaAttivitaDate'])),
        'prossimaAttivitaModalita': json['prossimaAttivitaModalita'] == null ? undefined : json['prossimaAttivitaModalita'],
    };
}
export function ProssimaAttivitaPerClienteDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'idCliente': value['idCliente'],
        'nomeCliente': value['nomeCliente'],
        'ultimaAttivitaDate': value['ultimaAttivitaDate'] == null ? undefined : ((value['ultimaAttivitaDate']).toISOString().substring(0, 10)),
        'ultimaAttivitaModalita': value['ultimaAttivitaModalita'],
        'ultimaAttivitaEsito': value['ultimaAttivitaEsito'],
        'prossimaAttivitaDate': value['prossimaAttivitaDate'] == null ? undefined : ((value['prossimaAttivitaDate']).toISOString().substring(0, 10)),
        'prossimaAttivitaModalita': value['prossimaAttivitaModalita'],
    };
}
